export enum TabType {
  EARNINGS = 'Earnings',
  ADJUSTMENTS = 'Adjustments',
}

export enum SearchType {
  BASIC_SEARCH = 'Basic Search',
  ADVANCED_SEARCH = 'Advanced Search',
}

export enum ToggleType {
  SHOW = 'show',
  HIDE = 'hide',
}

export enum EnterpriseIdSelectionType {
  SELF = 'self',
  OTHER = 'other',
  INTERNAL = 'internal',
}

export const SearchTypeLabel: Record<string, SearchType> = {
  basic: SearchType.BASIC_SEARCH,
  advanced: SearchType.ADVANCED_SEARCH,
};

export enum DownloadType {
  EARNING = 'Earning',
  DISBURSEMENT = 'Disbursement',
}

export interface DownloadCsvEventDetails {
  enterpriseIdSelectionType?: EnterpriseIdSelectionType;
  isDtcc?: boolean;
  disbursementPaidDateIndex?: number;
}
